package com.nonopn.skywatcher.maps.cache

import kotlinx.coroutines.CoroutineScope

actual class MultiplatformCache actual constructor(
    scope: CoroutineScope,
    cacheDirName: String,
    maxCacheSize: Int,
    download: suspend (x: Int, y: Int, z: Int) -> ByteArray
) {
    actual suspend fun initialize() {
        // nothing
    }

    actual fun cacheTile(x: Int, y: Int, z: Int) {
        // nothing
    }

    actual suspend fun reset() = Unit

    actual suspend fun getCached(x: Int, y: Int, z: Int): kotlinx.io.Buffer? = null
}
